export const NavigationLabel = {
    VSPEC: 'Retail Management'
  };
  
  export const ActionLabel = {
    RDR: 'RDR',
    PPO: 'PPO',
    INVOICE: 'Invoice',
    TRADE: 'Trade',
    MONRONEY: 'Monroney',
    VSPEC: 'V-Spec',
    DETAILS: 'Details',
    ACTIONS: 'Actions +'
  };
  
  export const VspecScreenLabel = {
    DELETE: 'Delete VSPEC',
    GRID_LABEL: 'Customer V Spec(s)'
  };
  
  export const VinLabel = {
    VIN_COPIED: 'VIN copied'
  };
  
  export const CustomLandingPageLabel = {
      CREATE_CUSTOMPAGE:'The custom landing page is created successfully in new tab',
      CUSTOMPAGE_CANT_CREATE: 'Custom Vspec page cannot be created',
      CUSTOMPAGE_ERROR: 'There was some problem in creating the V-Spec page. Please try again later. Sorry for the inconvenience.',
      USERMESSAGE_PHONENUMBER:'Contact your system admin to add/update phone number.'
   };

  export const VspecPageLabel = {
    VSPEC_DOWNLOAD_ERROR: 'There was some problem in creating the V-Spec for some write-ups.',
  };
  
  export const VSpecOperation = {
    MAX_VSPECS: 6
  };
  
  export const ImageLabel = {
    ICON_NO_IMAGE_HREF: '/assets/images/vehicle-no-image-left.png',
    ICON_NO_IMAGE_NIGHT_HREF: '/assets/images/vehicle-no-image-left-night.png',
    PROFILE_IMAGE_TAG: 'DS profile'
  }

  export const MessageLabel = {
    ICON_MESSAGE_HREF: '/assets/images/comment.svg',
    PROFILE_IMAGE_TAG: 'Message Icon'
  }
  export const MoveImage = {
    ICON_MESSAGE_HREF: '/assets/images/move.svg',
    PROFILE_IMAGE_TAG: 'Move Icon'
  }
  
  export const QuickSearchMode = {
      INVENTORY: 'inventory',
      LOCATE: 'locate'
  }

  export const VspecFooter = {
    PRICE_DISCLAIMER:
      'Manufacturer’s Suggested Retail Price, excludes the Delivery, ' +
      'Processing and Handling Fee, taxes, license, title and available or regionally required ' +
      'equipment. Actual Dealer price may vary. Pricing, fuel economy, specification, standard features and ' +
      'available equipment are based on information available when this page was produced and ' +
      'subject to change without notice.',
    DOCUMENT_DISCLAIMER:
      'Disclaimer: This document is only representative of some of the ' +
      'information contained on an actual window sticker, and is not meant to replace or ' +
      'substitute for the actual window sticker on the vehicle. Please see your retailer for ' +
      'further information.',
  };
